import { render } from "./AboutProgress.vue?vue&type=template&id=273552fd&scoped=true"
import script from "./AboutProgress.vue?vue&type=script&lang=js"
export * from "./AboutProgress.vue?vue&type=script&lang=js"

import "./AboutProgress.vue?vue&type=style&index=0&id=273552fd&scoped=true&lang=scss"

import exportComponent from "/Users/admin/Desktop/Israr/vue/matrixlimos/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-273552fd"]])

export default __exports__